import React from 'react';
import FileList, { ViewOrDownload } from '../shared/FileList';
import { docTypeBadge, fmtBytes } from './constants';

// A request's own attachments, read-only (docs/workflow-ui.md §4.3).
// Engagement-master documents (current/superseded versions) stay with
// shared/EngagementAttachments; the editable counterpart inside a Modify modal
// is EditableAttachments. All three print their rows with shared/FileList.
//
//   files        — [{ id, originalName, sizeBytes, docType }]
//   downloadHref — (f) => url
//   badgeFor     — optional (f) => [label, cls] override (defaults to docType map)
const AttachmentsList = ({
  files = [],
  downloadHref,
  badgeFor = null,
  emptyText = 'No files attached.',
}) => (
  <FileList
    files={files}
    emptyText={emptyText}
    row={(f) => ({
      name: f.originalName,
      badges: [badgeFor ? badgeFor(f) : docTypeBadge(f.docType)],
      meta: [f.sizeBytes != null ? fmtBytes(f.sizeBytes) : null],
      actions: <ViewOrDownload href={downloadHref(f)} name={f.originalName} />,
    })}
  />
);

export default AttachmentsList;
